const SET_IS_ONLINE = "jola/application/SET_IS_ONLINE";

const TYPES = {
  SET_IS_ONLINE,
};

export default TYPES;
